import React, { ChangeEvent } from 'react'
import { l } from '@manychat/manyui'

import FormulaInput from 'common/fields/components/FormulaInput/FormulaInput'

import { SearchInput } from '../FieldValuePicker/components/SearchInput'

import cm from './NumberInput.module.css'

type Value = number

type ChangeValueEvent = ChangeEvent<{ value: Value }>

interface NumberInputProps {
  value: number
  isBuilder: boolean
  onChange: (event: ChangeValueEvent, closePopover?: boolean) => void
}

export const NumberInput: React.FC<NumberInputProps> = ({ value, isBuilder, onChange }) => {
  const handleChange = (event: { target: { value: string | number } }) => {
    onChange(event as ChangeValueEvent)
  }

  return isBuilder ? (
    <div className="p-a">
      <FormulaInput
        value={value || ''}
        onChange={handleChange}
        placeholder={l.translate('Enter formula')}
        errorsClassName={cm.formulaErrors}
      />
    </div>
  ) : (
    <SearchInput
      value={value || ''}
      onChange={handleChange}
      placeholder={l.translate('Enter text')}
      ariaLabel={l.translate('Enter text')}
    />
  )
}
